import EditClientAllocation from './EditClientAllocation';

export default EditClientAllocation;
